/**
 * FieldAutocomplete
 *
 * Sistema di autocomplete per campi form basato su configurazione JSON.
 * Legge la configurazione da tag <script type="application/json"> e applica
 * jQuery UI autocomplete ai campi specificati.
 *
 * Supporta:
 * - Autocomplete con chiamata AJAX a endpoint configurabile
 * - Campi parent per dipendenze (parent_value)
 * - MinLength configurabile
 * - Validazione automatica al select
 */
const FieldAutocomplete = function() {

    let configCache = {};

    /**
     * Carica la configurazione JSON dal DOM
     * @param {string} configId - ID dello script di configurazione
     * @returns {Object|null} La configurazione parsata o null
     */
    function loadConfig(configId) {
        // Controlla cache
        if (configCache[configId]) {
            return configCache[configId];
        }

        const configElement = document.getElementById(configId);

        if (!configElement) {
            console.warn('[FieldAutocomplete] Config element not found:', configId);
            return null;
        }

        try {
            const config = JSON.parse(configElement.textContent);
            configCache[configId] = config;

            // Rimuovi l'elemento dal DOM per pulire l'HTML
            configElement.parentNode.removeChild(configElement);

            return config;
        } catch (error) {
            console.error('[FieldAutocomplete] Failed to parse configuration:', configId, error);
            return null;
        }
    }

    /**
     * Costruisce il selettore jQuery per il campo
     * @param {Object} config - Configurazione del campo
     * @returns {string} Selettore jQuery
     */
    function buildFieldSelector(config) {
        // Supporta sia formId che blockId+formId (tema saasland)
        const formSelector = config.blockId
            ? "#" + config.blockId + "_" + config.formId
            : "#" + config.formId;

        return formSelector + " input[name='" + config.fieldName + "']";
    }

    /**
     * Inizializza l'autocomplete per un campo
     * @param {Object} config - Configurazione del campo
     * @returns {boolean} True se inizializzato con successo
     */
    function initFieldAutocomplete(config) {
        const fieldSelector = buildFieldSelector(config);
        const $field = $(fieldSelector);

        if (!$field.length) {
            console.warn('[FieldAutocomplete] Field not found:', fieldSelector);
            return false;
        }

        try {
            // Determina il container per appendTo
            const containerClass = config.containerClass || 'form-group';
            const appendTo = config.appendToContainer !== false
                ? $field.closest('.' + containerClass)
                : undefined;

            // Configura jQuery UI autocomplete
            $field.autocomplete({
                minLength: config.minLength || 2,
                appendTo: appendTo,
                source: function (request, response) {
                    const input = $(this)[0].element[0];
                    let parent_value;

                    // Leggi parent_value se configurato
                    if (config.parentField) {
                        parent_value = $(input.closest('form')).find("[name='" + config.parentField + "']").val();
                    }

                    // Chiamata AJAX per ottenere i suggerimenti
                    $.ajax({
                        url: config.url,
                        method: "GET",
                        dataType: "json",
                        context: this,
                        data: {
                            term: request.term,
                            parent_value: parent_value
                        },
                        success: function (data) {
                            if (data) {
                                response(data);
                            }
                        },
                        error: function(jqXHR, textStatus, errorMessage) {
                            console.error('[FieldAutocomplete] AJAX error for field:', config.fieldName, errorMessage);
                            response([]);
                        }
                    });
                },
                select: function (e, ui) {
                    e.preventDefault();
                    // Imposta il valore
                    $field.val(ui.item.value);

                    // Triggera la validazione se disponibile (con timeout per compatibilità)
                    if (typeof $field.valid === 'function') {
                        setTimeout(function() {
                            $field.valid();
                        }, 100);
                    }
                }
            });

            return true;

        } catch (error) {
            console.error('[FieldAutocomplete] Error initializing autocomplete for field:', config.fieldName, error);
            return false;
        }
    }

    /**
     * Auto-inizializza tutti i campi che hanno configurazione JSON
     */
    function autoInitialize() {
        $('script[id^="field-autocomplete-config-"]').each(function() {
            const configId = $(this).attr('id');
            const config = loadConfig(configId);

            if (config) {
                initFieldAutocomplete(config);
            }
        });
    }

    /**
     * Resetta la cache (utile per testing)
     */
    function resetCache() {
        configCache = {};
    }

    // API pubblica
    return {
        /**
         * Inizializza l'autocomplete per un campo specifico
         * @param {string} configId - ID della configurazione
         */
        init: function(configId) {
            const config = loadConfig(configId);
            if (config) {
                return initFieldAutocomplete(config);
            }
            return false;
        },

        /**
         * Auto-inizializza tutti i campi
         */
        autoInit: function() {
            autoInitialize();
        },

        /**
         * Resetta la cache
         */
        reset: function() {
            resetCache();
        }
    };

}();

// Auto-inizializza quando il DOM è pronto
document.addEventListener('DOMContentLoaded', function() {
    FieldAutocomplete.autoInit();
});
